// Cloudy Meals theme JS

function toggleMobileNav() {
  const header = document.querySelector('.header');
  if (!header) return;

  header.classList.toggle('nav-open');

  const btn = header.querySelector('.nav-toggle');
  if (!btn) return;

  const isOpen = header.classList.contains('nav-open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

function closeMobileNav() {
  const header = document.querySelector('.header');
  if (!header) return;
  header.classList.remove('nav-open');

  const btn = header.querySelector('.nav-toggle');
  if (!btn) return;
  btn.setAttribute('aria-expanded', 'false');
}

function toggleFaq(el) {
  if (!el) return;
  const item = el.closest('.faq-item');
  if (!item) return;
  item.classList.toggle('is-open');
}

document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      toggleMobileNav();
    });
  }

  document.querySelectorAll('.nav-links a').forEach(function (link) {
    link.addEventListener('click', function () {
      closeMobileNav();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  document.addEventListener('click', function (e) {
    const header = document.querySelector('.header');
    if (!header) return;

    const isOpen = header.classList.contains('nav-open');
    if (!isOpen) return;

    const nav = header.querySelector('.nav');
    if (!nav) return;

    if (!nav.contains(e.target)) {
      closeMobileNav();
    }
  });
});
